import type { TFunction } from "i18next"
import type { SkillSpecialty } from "@/types/__generated__/union-types"

export const getLocalizedSpecialty = (t: TFunction, specialty: SkillSpecialty): string =>
  t(`scheduling.waitingRoom.filters.serviceSpecialtyFilter.${specialty}`)

export const getLocalizedSpecialties = (t: TFunction, specialties: readonly SkillSpecialty[]): string =>
  specialties.map((specialty) => getLocalizedSpecialty(t, specialty)).join(", ")

export const getLocalizedShiftType = (t: TFunction, code: string): string =>
  t(`shiftPlanOverview.shiftTypes.${code}`, { defaultValue: code })

export const getLocalizedQualification = (t: TFunction, code: string): string =>
  t(`shiftPlanOverview.qualifications.${code}`, { defaultValue: code })

const SHIFT_TYPE_COLORS: Record<string, { background: string; text: string }> = {
  ALLG: { background: "var(--primary-surface)", text: "var(--on-primary-surface)" },
  CHAT: { background: "var(--lilac-surface)", text: "var(--on-lilac-surface)" },
  CHAT2: { background: "var(--lilac-surface-subdued)", text: "var(--on-lilac-surface)" },
  PAEDI: { background: "var(--ochre-surface)", text: "var(--on-ochre-surface)" },
  IMPF: { background: "var(--success-surface)", text: "var(--on-success-surface)" },
  FKARDIO: { background: "var(--critical-surface)", text: "var(--on-critical-surface)" },
  FSPORT: { background: "var(--primary)", text: "var(--on-primary)" },
  FGYN: { background: "var(--pink-surface)", text: "var(--on-pink-surface)" },
  FDERMA: { background: "var(--plum-surface)", text: "var(--on-plum-surface)" },
  FURO: { background: "var(--success)", text: "var(--on-success)" },
  ABaD: { background: "var(--ochre)", text: "var(--on-warning)" },
  MEDSUP: { background: "var(--critical)", text: "var(--on-critical)" },
  ADHOC: { background: "var(--surface-subdued)", text: "var(--on-surface)" },
  TRAINEE: { background: "var(--plum)", text: "var(--on-critical)" },
}

const DEFAULT_SHIFT_COLORS = { background: "var(--primary-surface)", text: "var(--on-primary-surface)" }

export const getShiftColors = (shiftType: string | null | undefined): { background: string; text: string } => {
  if (!shiftType) return DEFAULT_SHIFT_COLORS
  return SHIFT_TYPE_COLORS[shiftType] ?? DEFAULT_SHIFT_COLORS
}
